import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import './index.scss';
import { errors } from '../../utils/errors';
import { emptyError } from '../../redux/actions/userActions';

const Toast = ({ error, isDNI }) => {
  const [showToast, setShowToast] = useState(false);
  const dispatch = useDispatch();

  const handleShowToast = () => {
    setShowToast(true);
    setTimeout(() => {
      setShowToast(false);
      dispatch(emptyError());
    }, 3000);
  };

  useEffect(() => {
    if (error) {
      handleShowToast();
    }
  }, [error]);

  return (
    <div>
      {showToast && <div className="toast">{errors[isDNI ? `${error}_DNI` : error]}</div>}
    </div>
  );
};

Toast.propTypes = {
  error: PropTypes.string,
  isDNI: PropTypes.bool,
};

Toast.defaultProps = {
  error: null,
  isDNI: false,
};

export default Toast;
